import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ProfileComponent } from "./profile/profile.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { AuthGuard } from "../services/permission/permissions.service";
import { SettingsComponent } from "./settings.component";
import { SystemPropertyComponent } from "./system-property/system-property.component";


const routes: Routes = [
  {
    path: "settings",
    component: SettingsComponent,

    children: [
      {
        path: "profile",
        component: ProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "system-properties",
        component: SystemPropertyComponent,
        canActivate: [AuthGuard]
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {}
